import type { NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Kerning',
    description: "A scout network for hiring designers. Respected people in the design community hand-pick every introduction, so every conversation starts with interest on both sides.",
    url: getOrigin()
}

export const routes = {
    home: '/',
    howItWorks: '/how-it-works',
    placements: '/placements',
    becomeAScout: '/become-a-scout',
    blog: '/blog',
    terms: '/terms',
    privacy: '/privacy',
    getStarted: '/get-started',
    applyToScout: '/become-a-scout/apply',
    logIn: '/log-in'
} as const

export const primaryNav: NavItem[] = [
    { label: "How it works", href: routes.howItWorks },
    { label: "Placements", href: routes.placements },
    { label: "Become a Scout", href: routes.becomeAScout },
    { label: "Blog", href: routes.blog }
]

export const legalNav: NavItem[] = [
    { label: "Terms of Service", href: routes.terms },
    { label: "Privacy Policy", href: routes.privacy }
]
